import { render, staticRenderFns } from "./GenericLink.vue?vue&type=template&id=520f434d"
import script from "./GenericLink.vue?vue&type=script&lang=js"
export * from "./GenericLink.vue?vue&type=script&lang=js"
import style0 from "../../BankInformation/bkCuenta.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../Cuenta/cuentaMenu.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "../Usuarios/usuariosAdmin.css?vue&type=style&index=2&prod&lang=css&external"
import style3 from "./linksAdmin.css?vue&type=style&index=3&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports